import * as React from 'react';
export const SearchFieldPopoverContext = React.createContext(undefined);
export function useSearchFieldPopoverContext() {
    return React.useContext(SearchFieldPopoverContext);
}
